import { Box, Container } from '@material-ui/core';
import welcomeAccount from '../../../assets/boite_a_idees.svg';
import classNames from 'classnames';
import React, { useState } from 'react';

import styles from './BoiteAIdees.module.scss';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { SGSButton, SGSForm, SGSFormInput, SGSHelpButton } from 'components';
import { toast } from 'react-toastify';
import { contactService } from 'core/services';
import { useAppContext } from 'core/contexts';

type ContactForm = {};

type Props = {};

const BoiteAIdee: React.FC<Props> = () => {
    const { user } = useAppContext();
    const validationSchema: Yup.SchemaOf<ContactForm> = Yup.object().shape({
        commentaire: Yup.string().required(),
    });

    const [isFormSubmitted, setisFormSubmitted] = useState(false);

    const methods = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {},
    });
    const {
        handleSubmit,
        reset,
        //formState: { errors },
    } = methods;

    const handleSendForm = async (values) => {
        values.raison = 'boiteAidee';
        values.user = { id: user.id, prenom: user.prenom, nom: user.nom, email: user.login, num_adherent: user.num_adherent };
        setisFormSubmitted(true);
        contactService
            .sendBoiteAIdeeForm(values)
            .then(() => {
                reset();
                toast.success('Demande envoyée avec succès');
            })
            .finally(() => {
                setisFormSubmitted(false);
            });
    };

    return (
        <FormProvider {...methods}>
            <SGSHelpButton />
            <Container maxWidth="xl">
                <SGSForm.Card onSubmit={handleSubmit(handleSendForm)} shadow={false} maxWidth="xl">
                    <Box display="flex" flexDirection="row" flexGrow="1" height="100%" maxWidth="100%" className="mb-5">
                        {/* Column left */}
                        <Box display="flex" className="p-5">
                            <img src={welcomeAccount} alt="bgOne" width={'428px'} height={'313px'} />
                        </Box>
                        {/* Column right */}
                        <Box display="flex" flexGrow="1">
                            <Box display="flex" flexGrow="1" flexDirection="column">
                                <Box flexDirection="column" className={classNames(styles.SGSSubTitle, 'ml-5 mt-5 text-center', styles.btnSubmit)}>
                                    Des idées d’améliorations sur notre site ? Dites-le nous !
                                </Box>

                                <Box className={classNames(styles.textarea, 'ml-5 mr-5 mt-3')}>
                                    <SGSFormInput variant="outlined" name="commentaire" label="contact.comments" multiline fullWidth minRows={15} />
                                </Box>
                                <Box className={classNames(styles.textarea, 'ml-5 mr-5 mt-3 mb-5')}>
                                    <Box className={classNames(styles.SGSEncartBkgBlueDark, 'mt-4 text-center', styles.btnSubmit)}>
                                        <SGSButton type="submit" icon={'fa fa-comment'} loading={isFormSubmitted}>
                                            ENVOYER
                                        </SGSButton>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </SGSForm.Card>
            </Container>
        </FormProvider>
    );
};

export default BoiteAIdee;
